import { observer } from 'mobx-react-lite';
import type { ReactElement } from 'react';

import { useSDK } from '../../../../app';
import { FilePreview } from './filePreview';
import { ImagePreview } from './imagePreview';

const Component = ({ id }: { id: number; fromClient: boolean }): ReactElement | null => {
	const rootStore = useSDK();
	const attachmentInfo = rootStore.attachmentsStore.getAttachmentInfo(id);
	if (!attachmentInfo) return null;
	return attachmentInfo?.mimeType.includes('image/') ? (
		<ImagePreview attachmentMeta={attachmentInfo} showcaseId={rootStore.showcaseId} />
	) : (
		<FilePreview id={id} />
	);
};

const AttachmentPreview = observer(Component);

export { AttachmentPreview };
